import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import  'normalize.css/normalize.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import "@blueprintjs/icons/lib/css/blueprint-icons.css"




ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js